<app-modal-shell [showFooter]="true"
  [dismissLabel]="'general.close' | translate"
  (dismiss)="dismiss()">
  <div modalTitle>
    <h2>{{ 'templates.project' | translate }}</h2>
  </div>

  <form class="project-template-modal"
    [formGroup]="formGroup"
    (ngSubmit)="save()">
    <div class="project-template-modal__field">
      <label class="project-template-modal__label">{{ 'templates.name' | translate }}</label>
      <input class="project-template-modal__input"
        autocapitalize="on"
        formControlName="name" />
    </div>

    <div class="project-template-modal__field-header">
      <label class="project-template-modal__label">{{ 'additionalInfo.addJob' | translate }}</label>
      <button class="project-template-modal__add-button"
        type="button"
        (click)="addItem()">
        {{ 'additionalInfo.addJob' | translate }}
      </button>
    </div>

    <div formArrayName="periods"
      class="project-template-modal__periods">
      @for (item of periodsArray.controls; track item; let i = $index) {
        <div [formGroupName]="i"
          class="project-template-modal__period">
          <div class="project-template-modal__field-row">
            <input class="project-template-modal__input"
              autocapitalize="on"
              formControlName="name"
              [placeholder]="'additionalInfo.phaseName' | translate" />
            <button class="project-template-modal__remove"
              type="button"
              (click)="deleteItem(i)">
              {{ 'general.delete' | translate }}
            </button>
          </div>

          <div class="project-template-modal__tickets-header">
            <span>{{ 'templates.addTicket' | translate }}</span>
            <button class="project-template-modal__add-button"
              type="button"
              (click)="addTicket(i)">
              {{ 'templates.addTicket' | translate }}
            </button>
          </div>

          <div formArrayName="tickets"
            class="project-template-modal__tickets">
            @for (ticket of periodTicketsArrays[i].controls; track ticket; let j = $index) {
              <div [formGroupName]="j"
                class="project-template-modal__field-row">
                <input class="project-template-modal__input"
                  autocapitalize="on"
                  formControlName="name"
                  [placeholder]="'templates.ticketName' | translate" />
                <button class="project-template-modal__remove"
                  type="button"
                  (click)="deleteTicket(i, j)">
                  {{ 'general.delete' | translate }}
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </form>

  <div modalFooter>
    <button class="project-template-modal__button project-template-modal__button--secondary"
      type="button"
      (click)="dismiss()">
      {{ 'general.cancel' | translate }}
    </button>
    <button class="project-template-modal__button project-template-modal__button--primary"
      type="button"
      [disabled]="!formGroup.valid"
      (click)="save()">
      {{ 'general.save' | translate }}
    </button>
  </div>
</app-modal-shell>